import CierresLayout from './CierresLayout.vue';
import CalendarioPage from './calendario/CalendarioPage.vue';
import EjecucionesPage from './ejecucion/EjecucionesPage.vue';
import EjecucionDetallePage from './ejecucion/EjecucionDetallePage.vue';

export const cierresRoutes = {
  path: 'cierres',
  component: CierresLayout,
  children: [
    {
      path: 'calendarios',
      name: 'Calendarios',
      component: CalendarioPage   ,
      meta: {
        moduleAccess: 'Calendario'
      }       
    },
    {
      path: 'ejecuciones/detalle/:id',
      name: 'Detalle',
      component: EjecucionDetallePage,
      props: {modoEditar: true} ,
      meta: {
        moduleAccess: 'Cierres'
      }    
    },
    {
      path: 'ejecuciones/ver/:id',
      name: 'Ver',
      component: EjecucionDetallePage,
      props: {modoEditar: false} ,
      meta: {
        moduleAccess: 'Cierres'
      }    
    },
    {
      path: 'ejecuciones',
      name: 'Presentes / Futuras',
      component: EjecucionesPage,
      props: {historico: false},
      meta: {
        moduleAccess: 'Cierres'
      }    
    },    
    {
      path: 'historicos',
      name: 'Historicos',
      component: EjecucionesPage,
      props: {historico: true},
      meta: {
        moduleAccess: 'Cierres'
      }    
    }
   
  ],
  meta: {
    moduleAccess: 'Cierres',
    requireAuth: true,
    title: 'nav_bar.example'
  }
};